export function updateSpecialOrderColors(html) {
  if (html === undefined || html === null) return
  
  const holder = getHolder()
  const mobileHolder = getMobileHolder()
  
  if (!holder && !mobileHolder) return
  
  const collapse = getCollapse()
  const wasCollapsed = isCollapsed(collapse)
  
  if (holder) {
    updateHolderContent(holder, html)
  }
  
  if (mobileHolder) {
    updateHolderContent(mobileHolder, html)
  }
  
  if (wasCollapsed) {
    restoreCollapsedState()
  }
}

function getHolder() {
  return document.getElementById('special-order-colors-holder')
}

function getMobileHolder() {
  return document.getElementById('special-order-colors-holder-mobile')
}

function getCollapse() {
  return document.getElementById('specialOrderColorsCollapse')
}

function isCollapsed(collapse) {
  return collapse?.classList.contains('show')
}

function updateHolderContent(holder, html) {
  holder.innerHTML = html
}

function restoreCollapsedState() {
  const newCollapse = getCollapse()
  newCollapse?.classList.add('show')
  
  const chevron = newCollapse?.previousElementSibling?.querySelector('.fa-chevron-down')
  if (chevron) {
    chevron.style.transform = 'rotate(180deg)'
  }
}
